<template>
  <div>
    <user-detail-title
      first-bread="产品标签"
      second-bread="产品标签查看"
      first-url="/user/tag"
      title-name="产品标签查看"
    ></user-detail-title>
    <user-detail-base style="width: 60%;">
      <el-form label-position="left" label-width="100px" v-if="LookData">
        <el-form-item label="名称">
          <span>{{LookData.name}}</span>
        </el-form-item>
        <el-form-item label="图片">
          <el-image class="item-image" :src="'http://'+LookData.logoUrl" alt=""></el-image>
        </el-form-item>
        <el-form-item label="所属类型">
          <span>{{LookData.superLabelName}}</span>
        </el-form-item>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "../Common/UserDetailTitle";
  import UserDetailBase from "../Common/UserDetailBase";
  export default {
    name: "TagLook",
    components: {UserDetailBase, UserDetailTitle},
    data(){
      return{
        LookData:null,
      }
    },
    created() {
      this.GetLookData(this.$route.params.id)
    },
    methods:{
      GetLookData(id){
        this.$axios.get('/api/tag/getById',{params:{
            id:id
          }}).then(res=>{
          this.LookData=res.data.data
        })
      }
    }
  }
</script>

<style scoped>

</style>